import Vue from 'vue';
import { setContext } from 'apollo-link-context';
import { ApolloLink } from 'apollo-link';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';
import VueApollo from 'vue-apollo';
import { onError } from '@apollo/client/link/error';
import { EventBus } from './event-bus';

const STAGE_URI = 'https://stage.zipper.solutions/graphql';
const MASTER_URI = 'https://master.zipper.solutions/graphql';

const isMaster = process.env.VUE_APP_LAYER_URL === MASTER_URI;

const uri = process.env.VUE_APP_LAYER_URL
  ? process.env.VUE_APP_LAYER_URL
  : MASTER_URI;

const contextLink = setContext(async () => {
  if (isMaster) return { uri };
  try {
    await fetch(uri, {
      method: 'POST',
      body: JSON.stringify({
        query: 'query root { root }',
        operationName: 'root',
      }),
    });
    return { uri };
  } catch (err) {
    return { uri: STAGE_URI };
  }
});

const httpLink = createHttpLink({
  uri,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('access_token');
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : null,
    },
  });
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors }) => {
  const emitSnackBar = (text) => {
    const snackBar = {};
    snackBar.text = text;
    snackBar.value = true;
    snackBar.color = 'red';
    EventBus.$emit('activeSnackBar', snackBar);
  };
  if (graphQLErrors && graphQLErrors.length > 0) {
    graphQLErrors.forEach((err) => {
      if (err.extensions.handled) {
        emitSnackBar(err.message);
      } else {
        emitSnackBar('Ocorreu um erro no sistema. Por favor, entre em contato com o suporte.');
      }
    });
  }
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, contextLink, authMiddleware.concat(httpLink)]),
  cache: new InMemoryCache({ resultCaching: false }),
  queryDeduplication: false,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
  },
});

Vue.use(VueApollo);

export default new VueApollo({
  defaultClient: apolloClient,
});
